export default __webpack_public_path__ + "feefa9e.png";